import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import { Router, Route, IndexRoute } from 'react-router'
import i18n from 'config/i18n'
import { I18nextProvider } from 'react-i18next'

// components / containers
import RequireAuth from 'container/RequireAuthentication'
import Public from 'container/Public'
import RequirePermission from 'container/RequirePermission'
import App from 'container/App'
import NewLogin from 'container/auth/NewLogin/index.js'
import PrivacyPage from 'container/privacyPage/PrivacyPage.js'
import PingAuthLogin from 'container/pingAuthLogin'
import ModuleOffline from 'component/utils/ModuleOffline'
import NoPermission from 'container/auth/NoPermission'
import Home from 'container/home/newHome'
import MenuMission from 'container/menuMission/MenuMission'
import MenuMissionView from 'container/menuMissionView/MenuMissionView'
import Rupture from 'container/report/rupture/Rupture'
import RuptureNew from 'container/report/rupture/RuptureNew'
import PreviousDayRupture from 'container/report/rupture/PreviousDayRupture'
import OlderRupture from 'container/report/rupture/OlderRupture'
import CommercialManagement from 'container/report/commercialManagement/CommercialManagement'
import MobileUpdate from 'container/mobileUpdate/MobileUpdate'
import MobileUpdateNew from 'container/mobileUpdateNew/MobileUpdate'
import OccurrencesCode8 from 'container/report/occurrencescode8/OccurrencesCode8'
import PreviousDayOccurrencesCode8 from 'container/report/occurrencescode8/PreviousDayOccurrencesCode8'
import OlderOccurrencesCode8 from 'container/report/occurrencescode8/OlderOccurrencesCode8'
import LmExpress from 'container/report/lmexpress/LmExpress'
import PreviousDayLmExpress from 'container/report/lmexpress/PreviousDayLmExpress'
import OlderLmExpress from 'container/report/lmexpress/OlderLmExpress'
import StockAdjustment from 'container/report/stockAdjustment/StockAdjustment'
import AdjustmentValuesNew from 'container/report/stockAdjustment/AdjustmentValuesNew'
import StockAdjustmentDone from 'container/report/stockAdjustment/StockAdjustmentDone'
import Suggestion from 'container/suggestion/Suggestion'
import SuggestionEdit from 'container/suggestion/SuggestionEdit'
import Video from 'container/video/Video'
import Analytics from 'container/analytics/Analytics'
import AnalyticsNew from 'container/analyticsNew/Analytics'
import AnalyticsFuncionalities from 'container/analyticsNew/mostFuncionalityTable/MostFuncionalityTable'
import AnalyticsRelatories from 'container/analyticsNew/mostRelatoryTable/MostRelatoryTable'
import MostAccessedMobile from 'container/analytics/MostAccessedMobile'
import MostAccessedWeb from 'container/analytics/MostAccessedWeb'
import LmExpressParameters from 'container/lmexpress/Parameters'
import IrcLists from 'container/ircLists/IrcListsNew'
import IrcListsSupply from 'container/ircListsSupply'
import ScheduleBlockList from 'container/scheduleBlock/List'
import Gama from 'container/newGama/Edit'
import ParamsSupply from 'container/paramsSupply'
import ParamsNexp from 'container/paramsNexp'
import OldGama from 'container/gama/Edit'
import Justifications from 'container/justification/Justifications'
import SalesCoaching from 'container/salesCoaching/SalesCoaching'
import IrcMenus from 'container/ircMenus/IrcMenus'
import RotativeInventory from 'container/rotativeInventory/RotativeInventory'
import RotativeInventoryNew from 'container/rotativeInventory/RotativeInventoryNew'
import v2RotativeInventory from './rotativeInventory/v2RotativeInventory'
import RuptureIrc from 'container/report/rupture/RuptureIrc'
import LinearConferenceReport from 'container/linearConference/LinearConferenceReport'
import StockTransferReportContainer from 'container/stockTransfer/ReportContainer'
import StockTransferReportContainerNew from 'container/stockTransferNew/ReportContainer'
import HigherAdjustments from 'container/higherAdjustments/HigherAdjustments'
import TrackingMonitor from 'container/trackingMonitor/TrackingMonitor'
import TotemReports from 'container/totemReports/TotemReports'
import TotemReportsNew from 'container/totemReportsNew/TotemReports'
import FeatureCheck from 'container/featureCheck/FeatureCheck'
import SectionBlockContainer from 'container/sectionBlock/SectionBlockContainer'
import DatasheetManagementContainer from 'container/datasheetManagement/DatasheetManagementContainer'
import NewDatasheetManagement from 'container/datasheetManagementNew/DatasheetManagement'
import TotalAccuracy from 'container/totalAccuracy/TotalAccuracy'
import SectionsAccuracyNew from 'container/sectionsAccuracy/SectionsAccuracyNew'
import LogoBrandsContainer from 'container/logoBrands/LogoBrandsContainer'
import Kardex from 'container/report/kardex/Kardex'
import SystemParameters from 'container/systemParameters/SystemParameters'
import TotemSystemParameters from 'container/totemSystemParameters/TotemSystemParameters'
import PunctualAdjustApprovers from 'container/punctualAdjustApprovers/PunctualAdjustApprovers'
import LocalUsers from 'container/localUsers/LocalUsers'
import QueryLogs from 'container/queryLogs/QueryLogs'
import QueryLogsNew from 'container/queryLogsNew/QueryLogs'
import JustificationsPa from 'container/justificationPa/JustificationsPa'
import JustificationLinearConference from 'container/justificationLinearConference/JustificationLinearConference'
import JustificationDemarcate from 'container/justificationDemarcate/JustificationDemarcate'
import JustificationDemarcateNew from 'container/justificationDemarcateNew/JustificationDemarcateNew'
import DemarcateDisapprovalJustification from 'container/demarcateDisapprovalJustification/DemarcateDisapprovalJustification'
import Help from 'container/helpConfiguration/HelpContainer'
import TotemLogContainer from 'container/totemLog/totemLogContainer'
import DelimitReportContainer from 'container/delimit/ReportContainer'
import DemarcateReportNew from 'container/report/Demarcate/DemarcateReportNew'
import StockTransferMissionBlockContainer from 'container/stockTransfer/MissionBlockContainer'
import StockTransferMissionBlockContainerNew from 'container/stockTransferNew/MissionBlockContainer'
import PictogramContainer from 'container/pictograms/PictogramContainer'
import UseConsumeJustification from 'container/useConsumeJustification/UseConsumeJustification'

import JustificationDisapprovalUseAndConsumption from 'container/justificationDisapprovalUseAndConsumption/JustificationDisapprovalUseAndConsumption'
import UsageConsumptionReport from 'container/usageConsumption/report/UsageConsumptionReport'
import ListExclusionSubType from 'container/exclusionSubtype/ListExclusionSubType'
import BeepingReport from 'container/BeepingReport/BeepingReport'
import NewOccurrenceCode8 from './occurrence-code-8-new/newOccurrenceCode8'

import ReportTeste from 'container/report/teste/Teste'
import DemarcateReportNewCopy from 'container/report/Demarcate/DemarcateReportCopy'
import ComponentShowCase from './componentShowCase/ComponentShowCase'
import pingAuthError from './pingAuthLogin/pingAuthError'
import AuditPrice from './auditPrice/AuditPrice'
import CommercialManagementNew from 'container/commercialManagement/commercialManagement'
import UseConsumeApprovers from './use-consume-approvers/UseConsumeApprovers'
import UsageConsumptionApprovers from './usageConsumptionApprovers/UsageConsumptionApprovers'
import SupplyPositionNotCounted from './supplyPositionNotCounted/supply'
import SupplyCountHistory from './supplyCountHistory/supply'
import useConsumeReport from './useConsumeReport/useConsumeReport'
import SupplyAccuracyEffectiveness from './supplyAccuracyEffectiveness/SupplyAccuracyEffectiveness'
import JustificationsIrc from './justifications-irc'
import PunctualAdjustParametersPerStore from './punctualAdjustPerStore/ParametersPerStore';
import ZeroCostDpacItems from './report/zeroCostDpacItems/ZeroCostDpacItems.js'
import IrcAutonomous from './ircAutonomous/IrcAutonomous'
import SystemParametersNew from './systemParameters/SystemParametersNew'
import ExternalApisManagement from './externalApisManagement/ExternalApisManagement'
import StockTransferApprovers from './stockTransferApprovers/StockTransferApprovers'
import PriceBannerConfigContainer from './priceBanner/PriceBannerConfigContainer'
import PriceBannerParamsContainer from './priceBanner/PriceBannerParamsContainer'
import PriceBannerListContainer from './priceBanner/PriceBannerListContainer'
import PriceBannerProductContainer from './priceBanner/PriceBannerProductContainer'
import SatisfactionSurveyContainer from './evaluations/SatisfactionSurveyContainer'
import DepositApproval from './depositApproval'

/**
 * Application routes
 * @param {Object} store - store
 * @param {Object} history - browser history
 */

const Root = ({ store, history }) => (
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <Router history={history}>
        <Route path='/' component={App}>
          <IndexRoute component={RequireAuth(Home)} />

          {/* Public routes */}
          <Route path='login' component={Public(NewLogin, false)} />
          <Route path='ping-auth' component={Public(PingAuthLogin, false)} />
          <Route path='ping-auth-error' component={Public(pingAuthError, false)} />
          <Route path='module-offline' component={Public(ModuleOffline)} />
          <Route path='no-permissions' component={Public(NoPermission)} />
          <Route path='privacy' component={Public(PrivacyPage, false)} />

          {/* Private routes */}
          <Route path='home' component={RequireAuth(Home)} />

          {/* missions */}
          <Route
            path='missions'
            component={RequirePermission(RequireAuth(MenuMission))}
          />

          {/* missions view */}
          <Route
            path='missions-view'
            component={RequirePermission(RequireAuth(MenuMissionView))}
          />

          {/* mobile-update */}
          <Route
            path='mobile-update'
            component={RequirePermission(RequireAuth(MobileUpdate))}
          />
          <Route
            path='release-updates'
            component={RequirePermission(RequireAuth(MobileUpdateNew))}
          />

          {/* feature-check */}
          <Route
            path='feature-check'
            component={RequirePermission(RequireAuth(FeatureCheck))}
          />

          {/* rupture */}
          <Route
            path='rupture'
            component={RequirePermission(RequireAuth(Rupture))}
          />

          <Route
            path='rupture/previous-day'
            component={RequirePermission(RequireAuth(PreviousDayRupture))}
          />
          <Route
            path='rupture/older'
            component={RequirePermission(RequireAuth(OlderRupture))}
          />
          <Route
            path='rupture-new'
            component={RequirePermission(RequireAuth(RuptureNew))}
          />

          {/* commercial-management */}
          <Route
            path='commercial-management'
            component={RequirePermission(RequireAuth(CommercialManagement))}
          />
          <Route
            path="commercial-management-new"
            component={RequireAuth(CommercialManagementNew)}
          />

          {/* code8-occurrences */}
          <Route
            path='occurrences-code8'
            component={RequirePermission(RequireAuth(OccurrencesCode8))}
          />
          <Route
            path='occurrences-code8/previous-day'
            component={RequirePermission(
              RequireAuth(PreviousDayOccurrencesCode8)
            )}
          />
          <Route
            path='occurrences-code8/older'
            component={RequirePermission(RequireAuth(OlderOccurrencesCode8))}
          />

          {/* lmexpress */}
          <Route
            path='lmexpress'
            component={RequirePermission(RequireAuth(LmExpress))}
          />
          <Route
            path='lmexpress/previous-day'
            component={RequirePermission(RequireAuth(PreviousDayLmExpress))}
          />
          <Route
            path='lmexpress/older'
            component={RequirePermission(RequireAuth(OlderLmExpress))}
          />

          {/* suggestion */}
          <Route
            path='suggestions'
            component={RequirePermission(RequireAuth(Suggestion))}
          />
          <Route
            path='suggestions/:id'
            component={RequirePermission(RequireAuth(SuggestionEdit))}
          />

          {/* video */}
          <Route
            path='videos'
            component={RequirePermission(RequireAuth(Video))}
          />

          {/* analytics */}
          <Route
            path='analytics'
            component={RequirePermission(RequireAuth(Analytics))}
          />

          {/* analytics new */}
          <Route
            path='analytics-new'
            component={RequireAuth(AnalyticsNew)}
          />

          <Route
            path='analytics-new/funcionalities'
            component={RequireAuth(AnalyticsFuncionalities)}
          />

          <Route
            path='analytics-new/relatories'
            component={RequireAuth(AnalyticsRelatories)}
          />

          <Route
            path='most-accessed-mobile'
            component={RequirePermission(RequireAuth(MostAccessedMobile))}
          />
          <Route
            path='most-accessed-web'
            component={RequirePermission(RequireAuth(MostAccessedWeb))}
          />

          {/* lmexpress */}
          <Route
            path='lmexpress/parameters'
            component={RequirePermission(RequireAuth(LmExpressParameters))}
          />

          {/* irc-lists */}
          <Route
            path='irc-lists'
            component={RequirePermission(RequireAuth(IrcLists))}
          />

          {/* irc-schedule-block */}
          <Route
            path='irc-schedule-block'
            component={RequirePermission(RequireAuth(ScheduleBlockList))}
          />
          <Route
            path='irc-lists-supply'
            component={RequirePermission(RequireAuth(IrcListsSupply))}
          />
          <Route
            path='irc-settings-gama'
            component={RequirePermission(RequireAuth(Gama))}
          />
          <Route
            path='irc-settings-gama-old'
            component={RequireAuth(OldGama)}
          />
          <Route
            path='params-supply'
            component={RequireAuth(ParamsSupply)}
          />

          <Route
            path='params-nexp'
            component={RequireAuth(ParamsNexp)}
          />

          {/* irc autonomous */}
          <Route
            path='irc-autonomous-parameters'
            component={(RequireAuth(IrcAutonomous))}
          />

          {/* justifications */}
          <Route
            path='justifications'
            component={RequirePermission(RequireAuth(Justifications))}
          />

          <Route
            path='justifications-irc'
            component={RequirePermission(RequireAuth(JustificationsIrc))}
          />


          <Route
            path='stock-transfer/deposit-approval'
            component={RequirePermission(RequireAuth(DepositApproval))}
          />

          {/* sales-coaching */}
          <Route
            path='sales-coaching'
            component={RequirePermission(RequireAuth(SalesCoaching))}
          />

          {/* stock-adjustment */}
          <Route
            path='stock-adjustment'
            component={RequirePermission(RequireAuth(StockAdjustment))}
          />
          <Route
            path='stock-adjustment/done'
            component={RequirePermission(RequireAuth(StockAdjustmentDone))}
          />

          {/* adjustment-values */}
          <Route
            path='adjustment-values'
            component={RequirePermission(RequireAuth(AdjustmentValuesNew))}
          />

          {/* usage-consumption-disapproval-justification */}
          <Route
            path='usage-consumption-disapproval-justification'
            component={RequirePermission(
              RequireAuth(JustificationDisapprovalUseAndConsumption)
            )}
          />

          {/* irc-menus */}
          <Route
            path='irc-menus'
            component={RequirePermission(RequireAuth(IrcMenus))}
          />

          {/* rotative-inventory */}
          <Route
            path='rotative-inventory-old'
            component={RequirePermission(RequireAuth(RotativeInventory))}
          />

          {/* rotative-inventory */}
          <Route
            path='rotative-inventory'
            component={RequirePermission(RequireAuth(RotativeInventoryNew))}
          />

          <Route
            exact path='v2/rotative-inventory'
            component={RequireAuth(v2RotativeInventory)}
          />

          {/* higher-adjustments */}
          <Route
            path='higher-adjustments'
            component={RequirePermission(RequireAuth(HigherAdjustments))}
          />

          {/* total-accuracy */}
          <Route
            path='total-accuracy'
            component={RequirePermission(RequireAuth(TotalAccuracy))}
          />

          <Route
            path='sections-accuracy'
            component={RequireAuth(SectionsAccuracyNew)}
          />

          <Route
            path='supply-accuracy-effectiveness'
            component={RequireAuth(SupplyAccuracyEffectiveness)}
          />

          {/* punctual-adjust-parameters
          <Route
            path='parameters'
            component={RequirePermission(RequireAuth(PunctualAdjustParameters))}
          /> */}

          {/* punctual-adjust-parameters-per-store */}
          <Route
            path='parameters-per-store'
            component={RequirePermission(RequireAuth(PunctualAdjustParametersPerStore))}
          />

          {/* section-block */}
          <Route
            path='section-block'
            component={RequirePermission(RequireAuth(SectionBlockContainer))}
          />

          {/* datasheet-management */}
          <Route
            path='datasheet-management'
            component={RequirePermission(
              RequireAuth(DatasheetManagementContainer)
            )}
          />
          <Route
            path='datasheet-management-new'
            component={RequirePermission(RequireAuth(NewDatasheetManagement))}
          />

          {/* logo-brands */}
          <Route
            path='logo-brands'
            component={RequirePermission(RequireAuth(LogoBrandsContainer))}
          />

          {/* kardex */}
          <Route
            path='kardex'
            component={RequirePermission(RequireAuth(Kardex))}
          />

          <Route
            path='zerocost-dpac-items'
            component={(RequireAuth(ZeroCostDpacItems))}
          />

          {/* systemParameters */}
          <Route
            path='system-parameters'
            component={RequirePermission(RequireAuth(SystemParameters))}
          />

          <Route
            path='system-parameters-new'
            component={RequirePermission(RequireAuth(SystemParametersNew))}
          />

          <Route
            path='external-apis'
            component={RequireAuth(ExternalApisManagement)}
          />

          {/* totemSystemParameters */}
          <Route
            path='totem/system-parameters'
            component={RequirePermission(RequireAuth(TotemSystemParameters))}
          />

          {/* totemLogs */}
          <Route
            path='totem-logs'
            component={RequirePermission(RequireAuth(TotemLogContainer))}
          />

          {/* rupture-irc */}
          <Route
            path='rupture-irc'
            component={RequirePermission(RequireAuth(RuptureIrc))}
          />

          {/* linear-conference */}
          <Route
            path='linear-conference/reports'
            component={RequirePermission(RequireAuth(LinearConferenceReport))}
          />
          <Route
            path='linear-conference/justifications'
            component={RequirePermission(
              RequireAuth(JustificationLinearConference)
            )}
          />

          {/* Stock transfer */}
          <Route
            path='stock-transfer/report'
            component={RequirePermission(
              RequireAuth(StockTransferReportContainer)
            )}
          />
          {/* Stock transfer */}
          <Route
            path='stock-transfer/report-new'
            component={RequirePermission(
              RequireAuth(StockTransferReportContainerNew)
            )}
          />

          {/* Stock transfer Approvers */}
          <Route
            path='stock-transfer-approvers'
            component={RequirePermission(
              RequireAuth(StockTransferApprovers)
            )}
          />

          {/* punctual-adjust-approvers */}
          <Route
            path='punctual-adjust-approvers'
            component={RequirePermission(RequireAuth(PunctualAdjustApprovers))}
          />

          {/* Local users */}
          <Route
            path='local-users'
            component={RequirePermission(RequireAuth(LocalUsers))}
          />

          {/* Tracking monitor */}
          <Route
            path='tracking-monitor'
            component={RequirePermission(RequireAuth(TrackingMonitor))}
          />

          {/* Totem reports */}
          <Route
            path='totem-reports'
            component={RequirePermission(RequireAuth(TotemReports))}
          />

          {/* Totem reports new */}
          <Route
            path='totem-reports-new'
            component={RequirePermission(RequireAuth(TotemReportsNew))}
          />

          {/* Query logs */}
          <Route
            path='query-logs'
            component={RequirePermission(RequireAuth(QueryLogs))}
          />
          <Route
            path='log-query'
            component={RequirePermission(RequireAuth(QueryLogsNew))}
          />

          {/* punctual-adjust-justifications */}
          <Route
            path='justifications-pa'
            component={RequirePermission(RequireAuth(JustificationsPa))}
          />

          {/* Register a help */}
          <Route
            path='help-configuration'
            component={RequirePermission(RequireAuth(Help))}
          />

          {/* Pricebanner config */}
          <Route
            path='pricebanner-config'
            component={RequirePermission(
              RequireAuth(PriceBannerConfigContainer)
            )}
          />

          {/* New Pricebanner config */}
          <Route
            path='pricebanner/parcel'
            component={RequirePermission(RequireAuth(PriceBannerParamsContainer))}
          />

          {/* Price Banner List Theme */}
          <Route
            path='pricebanner/list-themes'
            component={RequirePermission(RequireAuth(PriceBannerListContainer))}
          />

          {/* Price Banner Products */}
          <Route
            path='pricebanner/list-products'
            component={RequirePermission(RequireAuth(PriceBannerProductContainer))}
          />

          <Route
            path='satisfaction-survey'
            component={RequirePermission(RequireAuth(SatisfactionSurveyContainer))}
          />

          {/* Demarcate Justification */}
          <Route
            path='justification-demarcate'
            component={RequirePermission(RequireAuth(JustificationDemarcate))}
          />
          <Route
            path='demarcate-justifies'
            component={RequirePermission(
              RequireAuth(JustificationDemarcateNew)
            )}
          />

          {/* Demarcate Disapproval Justification */}
          <Route
            path='demarcate-disapproval-justification'
            component={RequirePermission(
              RequireAuth(DemarcateDisapprovalJustification)
            )}
          />

          {/* Delimit report */}
          <Route
            path='report/delimit'
            component={RequirePermission(RequireAuth(DelimitReportContainer))}
          />
          {/* Demarcate report new */}
          <Route
            path='demarcate-report-new'
            component={RequirePermission(RequireAuth(DemarcateReportNew))}
          />

          {/* Transfer block by mission */}
          <Route
            path='stock-transfer/mission-block'
            component={RequirePermission(
              RequireAuth(StockTransferMissionBlockContainer)
            )}
          />

          {/* New Transfer block by mission */}
          <Route
            path='stock-transfer/mission-block-new'
            component={
              RequireAuth(StockTransferMissionBlockContainerNew)
            }
          />

          <Route
            path='pictograms'
            component={
              RequireAuth(PictogramContainer)
            }
          />

          {/* Demarcate Justification */}
          <Route
            path='usage-consumption-justification'
            component={RequirePermission(RequireAuth(UseConsumeJustification))}
          />

          {/* Usage and Consumption Approvers */}
          <Route
            path='use-consume-approvers'
            component={RequirePermission(
              RequireAuth(UseConsumeApprovers)
            )}
          />

          {/* Usage and Consumption Approvers */}
          <Route
            path='usage-consumption-approvers'
            component={RequirePermission(
              RequireAuth(UsageConsumptionApprovers)
            )}
          />

          {/* Usage and Consumption Report */}
          <Route
            path='usage-consumption/report'
            component={RequirePermission(RequireAuth(UsageConsumptionReport))}
          />

          <Route
            path='use-consume/report'
            component={RequirePermission(RequireAuth(useConsumeReport))}
          />

          {/* Exclusion of sun type */}
          <Route
            path='exclusion-subtype'
            component={RequirePermission(RequireAuth(ListExclusionSubType))}
          />

          {/* Beeping report */}
          <Route
            path='beeping-report'
            component={RequirePermission(RequireAuth(BeepingReport))}
          />

          <Route
            path="price-audit"
            component={RequirePermission(RequireAuth(AuditPrice))}
          />

          <Route
            path="supply-positions-not-counted"
            component={RequireAuth(SupplyPositionNotCounted)}
          />


          <Route
            path="supply-count-history"
            component={RequireAuth(SupplyCountHistory)}
          />


          {/* New report poc testing */}
          <Route
            path='report/teste'
            component={RequireAuth(ReportTeste, true)}
          />

          {/* Components show case */}
          <Route
            path='component-showcase'
            component={RequirePermission(RequireAuth(ComponentShowCase))}
          />

          {/* New irc code 8 report */}
          <Route
            path='new-occurrence-code-8'
            component={RequireAuth(NewOccurrenceCode8)}
          />

          <Route
            path="new-relatory-component"
            component={RequireAuth(DemarcateReportNewCopy)} />
        </Route>
      </Router>
    </Provider>
  </I18nextProvider>
)

// Required fields for this component
Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
}

export default Root
